var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconV(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 3.33333V5.33333L8 2.66667L5.33333 0V2C2.38667 2 0 4.38667 0 7.33333C0 8.38 0.306667 9.35333 0.826667 10.1733L1.8 9.2C1.5 8.64667 1.33333 8.00667 1.33333 7.33333C1.33333 5.12667 3.12667 3.33333 5.33333 3.33333ZM9.84 4.49333L8.86667 5.46667C9.16 6.02667 9.33333 6.66 9.33333 7.33333C9.33333 9.54 7.54 11.3333 5.33333 11.3333V9.33333L2.66667 12L5.33333 14.6667V12.6667C8.28 12.6667 10.6667 10.28 10.6667 7.33333C10.6667 6.28667 10.36 5.31333 9.84 4.49333V4.49333Z",
    fill: "#045482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconV);
export default __webpack_public_path__ + "static/media/icon-v.130de06494e60bedfda70d1bf6e88e55.svg";
export { ForwardRef as ReactComponent };